<!--
 * @Author:
 * @Description:收单商户注册完成，进入入网申请
 * @Date: 2024-09-09 13:47:15
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/views/register/networkApplication/index.vue
-->
<template>
  <div class="network_application">
    <div class="logo">
      <img src="~@/assets/images/logo.png" height="40" />
      <div class="loginOut">
        <el-button @click="logout">{{ $t('message.user.logout') }}</el-button>
      </div>
    </div>
    <div :class="['step-box', currentLan]">
      <div class="subStep" v-for="(parentItem, parentIndex) in parentStepList" :key="parentIndex"
        :class="[formData.currentStep === parentItem.value ? 'active' : '']"
        :style="{ 'margin': parentIndex === 1 ? '20px 0' : '0' }" @click.stop="parentStepClick(parentIndex)">
        <div class="subStep-label">
          <span class="prefix">{{ parentIndex + 1 }}</span>
          <span class="label">{{ $t(parentItem.label) }}</span>
        </div>
        <div class="step-item-box"
          v-if="parentItem.childrenStepList && parentItem.childrenStepList.length > 0 && parentIndex === parentActive">
          <div v-for="(item, index) in parentItem.childrenStepList" :key="index" class="step-item"
            :class="[formData.currentStep === item.value && parentActive === parentIndex ? 'active' : '']"
            @click.stop="stepClick(item.value)">
            <span class="prefix"></span>
            <span class="label">{{ $t(item.label) }}</span>
          </div>
        </div>
      </div>
      <div class="step-bg"></div>
    </div>
    <div class="step-content">
      <!--这个组件的显示隐藏能加个过渡么 过渡柔和一点 时间久一点 该如何设置  -->
      <transition name="fade" mode="out-in">
        <component :is='stepComponent' :formData="formData" :ref="formData.currentStep" @updateFormData="updateFormData"
          @onlyUpdateForm="onlyUpdateForm" @editBusinessType="editBusinessType" v-bind="$attrs" v-on="$listeners">
        </component>
      </transition>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex/dist/vuex.common.js';

import { doLogout } from '@/api/common/user';
import { ShowSuccessMessage } from '@/components/modal/tips/message-tips.js';
import { removeLocalStorage } from '@/utils/tools/utils';

import { stepList, parentStepList } from './data';
import { saveMerchantInfo, getMerchantInfo } from '../api/index';
// 获取vuex的当前语言
export default {
  name: 'NetworkApplication',
  data() {
    return {
      freshComponent: true,
      loading: false,
      stepList,
      parentStepList,
      formData: {
        currentStep: 'businessType',
        businessType: {
          businessLocation: '', // 公司所在地
          typeOfBusiness: '', // 公司类型
        },
        businessDetails: {
          legalBusinessName: '',
          companyRegistrationNumber: '',
          companyRegistrationDate: '',
          businessName: '',
          businessPhoneNumber: '',
          registeredBusinessAddress: {
            location: '',
            areaOrCity: '',
            district: '',
            addressLine1: '',
            addressLine2: '',
            postalCode: '',
          },
          uploadCompanyCertificates: {
            certificateOfIncorporation: '', // 公司注册证书
            businessRegistrationCertificate: '', // 公司营业登记证书
            companyNnc1OrNar1: '', // 公司NNC1/NAR1
            explanationOfShareholdingStructure: '', // 股权结构说明
            articlesOfAssociation: '', // 公司章程
            extraDocument1: '', // 补充资料1
            extraDocument2: '', // 补充资料2
            extraDocument3: '', // 补充资料3
          },
        },
        businessRepresentative: {
          legalName: {
            firstName: '',
            lastName: '',
          },
          emailAddress: '',
          jobTitle: '',
          dateOfBirth: '',
          homeAddress: {
            location: '',
            areaOrCity: '',
            district: '',
            addressLine1: '',
            addressLine2: '',
            postalCode: '',
          },
          phoneNumber: '',
          personalIdNumber: '',
          uploadPersonalIdImages: {
            id: '',
            passport: '',
          },
        },
        // businessOwners: {
        //   legalName: {
        //     firstName: '',
        //     lastName: '',
        //   },
        //   emailAddress: '',
        // },
        businessOwners: [],
        websiteOrAppDetails: {
          businessWebsite: '',
          durationOfOperation: '',
          businessWebsiteType: '',
          websiteDefaultDomain: '',
          industryOrBusinessCategory: '',
          monthlyTradingVolumeUsd: '',
          monthlyDisputeRate: '',
          monthlyRefundRate: '',
          market: '',
          uploadBusinessProofs: {
            transactionStatementsLastThreeMonths: '',
            screenshotsOfBusinessPlatforms: '',
          },
        },
        bankAccount: {
          accountHolderName: '',
          depositBank: '',
          depositBranch: '',
          currency: '',
          accountNumber: '',
          confirmAccountNumber: '',
          uploadBankStatement: '',
          uploadExtraProofs: {
            extraDocument1: '',
            extraDocument2: '',
            extraDocument3: '',
            extraDocument4: '',
            extraDocument5: '',
          },
        },
      },
      parentActive: 0,
      isFirstLoad: true,
    };
  },
  computed: {
    ...mapGetters(['currentLan']),
    stepComponent() {
      return this.stepList.find(item => item.value === this.formData.currentStep).component;
    },
  },
  async created() {
    const res = await getMerchantInfo();
    console.log(res, 'res');

    if (res) {
      const { currentStep } = res;
      // 如果商户初始化进来查询到保存的步骤是《验证你的业务》中的表单
      const businessStepList = this.parentStepList[0].childrenStepList.map(item => item.value);
      // 设置父级选中
      businessStepList.includes(res.currentStep) && (this.parentActive = 0);
      // 如果商户初始化进来查询到保存的步骤是《验证你的业务》中的表单
      const bankAccountStepList = this.parentStepList[1].value;
      bankAccountStepList.includes(currentStep) && (this.parentActive = 1);
      // 如果商户初始化进来查询到保存的步骤是《验证你的业务》中的表单
      const checkStepList = this.parentStepList[2].childrenStepList.map(item => item.value);
      checkStepList.includes(currentStep) && (this.parentActive = 2);
      this.formData.currentStep = currentStep;
    }
  },
  methods: {
    stepClick(currentStep) {
      this.formData.currentStep = currentStep;
    },
    parentStepClick(index) {
      this.parentActive = index;
      switch (index) {
        case 0:
          this.formData.currentStep = this.parentStepList[index]?.childrenStepList[0]?.value;
          break;
        case 1:
          this.formData.currentStep = this.parentStepList[index]?.value;
          break;
        case 2:
          this.formData.currentStep = this.parentStepList[index]?.childrenStepList[0]?.value;
          break;
        default:
          break;
      }
    },
    async updateFormData(value) {
      try {
        this.loading = true;
        const { nextStep, showStatus, currentStep } = value;
        this.formData = { ...this.formData, ...value };
        await saveMerchantInfo(this.formData);
        this.formData.currentStep = nextStep;
        if (nextStep === 'bankAccount') {
          this.parentActive = 1;
        }
        if (nextStep === 'status' && currentStep === 'bankAccount') {
          this.parentActive = 2;
        }
        if (nextStep === 'status' && currentStep === 'status') {
          this.parentActive = 2;
          window.location.reload();
        }
        if (showStatus) {
          this.formData.currentStep = 'status';
        }
        this.loading = false;
        ShowSuccessMessage(this.$t('message.status.saveSuccess'));
      } catch (error) {
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    onlyUpdateForm(value) {
      this.formData = { ...this.formData, ...value };
    },

    logout() {
      const loading = this.$loading();
      // console.log('removeLocalStorage出发了吗');
      doLogout().then(() => {
        removeLocalStorage('userLogin');
        removeLocalStorage('BusinessTypes');
        window.location.href = '/user/login';
      }).catch(() => {
        loading.close();
      });
    },
    editBusinessType(type, index) {
      // 在status组件  状态不会更新
      this.formData.currentStep = type;
      this.parentActive = index;
    },
  },

};
</script>
<style lang="scss">
.network_application {
  .descript1 {
    font-weight: 600;
    font-size: 32px;
    color: #264373;
    line-height: 32px;
    text-align: left;
    font-style: normal;
  }

  .descript2 {
    font-weight: 400;
    font-size: 14px;
    color: #B7C4CE;
    line-height: 18px;
    text-align: left;
    font-style: normal;
    margin: 12px 0 24px;
  }
}
</style>
<style scoped lang="scss">
* {
  box-sizing: border-box;
}

@import '@/styles/element-variables.scss';

.network_application {
  height: 100vh;
  position: relative;
  padding-top: 80px;

  .logo {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 80px;
    line-height: 80px;
    padding: 0 95px;
    z-index: 100;
    background: #fff;

    .loginOut {
      position: absolute;
      top: 0;
      right: 12px;
    }
  }

  .step-box {
    position: fixed;
    width: 170px;
    right: calc(50% + 275px);
    // min-height: 225px;
    // background: $color-default;
    box-sizing: border-box;

    &.en {
      width: 250px;
    }

    .subStep {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 14px;
      color: #264373;
      line-height: 18px;
      text-align: left;
      font-style: normal;
      cursor: pointer;

      .subStep-label {
        display: flex;
        align-items: center;
        width: 100%;

        .prefix {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 20px;
          height: 20px;
          background: $color-primary;
          border-radius: 50%;
          margin-right: 16px;
          color: #fff;
          font-size: 14px;
        }

        .label {
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 14px;
          color: #264373;
          line-height: 18px;
          text-align: left;
          font-style: normal;
        }
      }
    }

    .step-item {
      display: flex;
      align-items: center;
      margin-top: 10px;
      font-size: 14px;
      font-weight: 600;
      color: $color-text-primary;
      line-height: 32px;
      cursor: pointer;

      &.active {
        color: $color-primary;

        .prefix {
          background: $color-primary;
        }
      }

      .prefix {
        width: 6px;
        height: 6px;
        background: #B7C4CE;
        border-radius: 50%;
        margin-left: 9px;
        margin-right: 35px;
      }
    }

    .step-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 24px;
      height: 100%;
      background: $color-default;
      border-radius: 26px;
      z-index: -1;
    }
  }

  .step-content {
    // 过渡动画
    width: 450px;
    margin: 0 auto;
    overflow-x: hidden;
    overflow-y: auto;
  }

}

.button-box {
  width: 100%;

  .el-button {
    width: 100% !important;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-in-out; // Adjust the duration and timing function as needed
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */
  {
  opacity: 0;
}
</style>
